const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Get related tables and columns for a specific table
export const getRelatedTablesSchema = async (tableName) => {
  try {
    const response = await fetch(`${API_URL}/api/TableSchema/GetRelatedTablesSchema/${tableName}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching related tables schema:', error);
    throw error;
  }
};

// Get all available tables in the database
export const getAllTables = async () => {
  try {
    const response = await fetch(`${API_URL}/api/TableSchema/GetAllTables`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getAuthToken()}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching all tables:', error);
    throw error;
  }
};

export default {
  getRelatedTablesSchema,
  getAllTables
};
